import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpService} from "../http.service";
import {environment} from "@shared-environments/environment";

@Injectable()
export class WhiteLabelTemplateService{


    constructor(private networkHelper: HttpService) { }

    private addByWhiteLabelUrl = '/white-label-template/save/:id';

    addByWhiteLabel(id: string){
        return this.networkHelper.post<any>(environment.apiURL + this.addByWhiteLabelUrl.replace(':id', id), {});
    }

}
